import { getGeoByAddress } from '../getGeoByAddress';
import { getOfferDraft } from '../getOfferDraft';
import { IPrepareOfferFromDraftParams, TPrepareOfferFromDraftResult } from './types';

export async function prepareOfferFromDraft(
  params: IPrepareOfferFromDraftParams,
): Promise<TPrepareOfferFromDraftResult> {
  const { httpApi, logger, draftGuid } = params;

  const offer = await getOfferDraft({ httpApi, draftGuid });

  logger.debug('getOfferDraft', { draftGuid, offer: JSON.stringify(offer) });

  if (!offer) {
    return null;
  }

  const {
    category,
    geo: { userInput },
  } = offer;

  const geo = await getGeoByAddress({ httpApi, category, userInput });

  logger.debug('getGeoByAddress', { category, userInput, geo: JSON.stringify(geo) });

  return {
    ...offer,
    geo: {
      ...offer.geo,
      ...geo,
    },
  };
}
